import { ROUTER_NAVIGATED, ROUTER_NAVIGATION } from "@ngrx/router-store";
import { createAction } from "@ngrx/store";

export const RouterNavigation = createAction(ROUTER_NAVIGATION);
export const RouterNavigated = createAction(ROUTER_NAVIGATED);
